export const breakpoint = 736
export const listColumnsLargeScreen = 3

// how often an already-open session re-fetches the catalog, so a staff
// item-availability toggle (route-item-availability.js) reaches other
// open kiosk/online sessions without waiting on a dataVersion bump (that
// bump is for structural catalog changes on deploy, not runtime toggles)
export const catalogPollIntervalMs = 30000
